import React, { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

// FAZ F — Üst barlardaki menüler `overflow: hidden` kapsayıcılar içinde
// kırpılmasın diye panel gövdesi body'ye portal'lanır ve düğmenin altına
// SABİT (fixed) konumlanır. Ekran kenarlarına sığdırılır.
export const DropdownPortal = ({ anchorRef, width = 320, onClose, testid, children }) => {
  const [pos, setPos] = useState(null);

  useLayoutEffect(() => {
    const hesapla = () => {
      const r = anchorRef?.current?.getBoundingClientRect();
      if (!r) return;
      const w = Math.min(width, window.innerWidth - 16);
      const left = Math.max(8, Math.min(r.right - w, window.innerWidth - 8 - w));
      const top = Math.min(r.bottom + 4, window.innerHeight - 80);
      setPos({ left, top, width: w, maxHeight: Math.max(160, window.innerHeight - top - 12) });
    };
    hesapla();
    window.addEventListener("resize", hesapla);
    window.addEventListener("scroll", hesapla, true);
    return () => {
      window.removeEventListener("resize", hesapla);
      window.removeEventListener("scroll", hesapla, true);
    };
  }, [anchorRef, width]);

  if (!pos) return null;

  return createPortal(
    <>
      <div className="fixed inset-0" style={{ zIndex: 1199 }} onClick={onClose} data-testid={testid ? `${testid}-backdrop` : undefined} />
      <div
        data-testid={testid}
        className="overflow-y-auto scrollbar-sertex"
        style={{ position: "fixed", left: pos.left, top: pos.top, width: pos.width, maxHeight: pos.maxHeight, zIndex: 1200 }}
      >
        {children}
      </div>
    </>,
    document.body,
  );
};

export default DropdownPortal;
